const news = {
  name: "news",
  label: "News Page Settings",
  file: "content/setting/news.md",

  fields: [
    {
      label: "Template",
      name: "template",
      widget: "hidden",
      default: "news",
      required: true,
    },
    {
      label: "Lead text for News Index",
      name: "intro",
      widget: "text",
      default: "",
      required: false,
    },
  ],
};
export default news;
